export function PopupUrgency({ closePopup }) {
    return <div className="popup-roles">
        <h1>מקרא צבעים לעורך הטאמבניילים </h1>
        <p><span className='green-text'>ירוק</span> : הסרטון בשלב ראשוני של הגיית הרעיון.</p>
        <p><span className='yellow-text'>צהוב</span> : הסרטון בשלב של כתיבת התסריט.</p>
        <p><span className='red-text'>אדום</span> : הסרטון בשלב מתקדם של הפקה וצריך טאמבנייל בדחיפות.</p>
        <div className="buttons-wrapper" style={{ marginTop: '40px' }}>
            <button className="bolder" onClick={closePopup}>הבנתי</button>
        </div>
    </div>
}